// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.js";


export let HolidayItem = function (date, name, shedule)
{
    BaseItem.call(this, null)
    this.date = date
    this.name = name
    this.shedule = shedule
}
HolidayItem.prototype = Object.create(BaseItem.prototype)

HolidayItem.prototype.ColumnCount = function ()
{
    return HolidayItem.columnsParams.length
}

HolidayItem.prototype.GetColumnParams = function (column)
{
    return HolidayItem.columnsParams[column]
}

HolidayItem.prototype.getColumnData = function (column)
{
    let val = this.getColumnValue(column)
    return { Value: val, FormattedValue: val ? val.toString() : '' }
}

HolidayItem.prototype.getColumnValue = function (column)
{
    switch (column)
    {
        case 0:
            return this.date
        case 1:
            return this.name
        case 2:
            return this.shedule
        default:
            return null
    }
}

HolidayItem.columnsParams = [
    new ColumnParams("InstrumentDetailsPanel.HolidayDate", 40, 0, true, true, true),
    new ColumnParams("InstrumentDetailsPanel.HolidayName", 40, 0, true, true, true),
    new ColumnParams("InstrumentDetailsPanel.HolidayType", 40, 0, true, true, true)
];